@if (isDesktop()) {
  <app-v3-earnings-desktop-content [isDetail]="true">
    <div left-column class="column-extra" [class.leading]="!epsData()">
      @if (hasUpdates()) {
        <ng-container
          [ngTemplateOutlet]="sectionTitle"
          [ngTemplateOutletContext]="{ label: 'Aus den Earnings', count: updatesCount() }"
        ></ng-container>
        <ng-container
          [ngTemplateOutlet]="updateTabs"
          [ngTemplateOutletContext]="{ icons: true }"
        ></ng-container>
        <div class="section-items" [appV3TabPanel]="activeUpdateTab()">
          <ng-container
            [ngTemplateOutlet]="updateItems"
            [ngTemplateOutletContext]="{ icons: true }"
          ></ng-container>
        </div>
      }

      @if (outlookText()) {
        <ng-container
          [ngTemplateOutlet]="sectionTitle"
          [ngTemplateOutletContext]="{ label: 'Ausblick' }"
        ></ng-container>
        <div class="section-items">
          <div class="update-item">
            <p class="update-text">{{ outlookText() }}</p>
          </div>
        </div>
      }
    </div>

    <div
      right-column
      class="column-extra"
      [class.leading]="!isEarningsDateEnabled() && !revenueStats()"
    >
      @if (developmentText() || earningsCallIntro()) {
        <ng-container
          [ngTemplateOutlet]="sectionTitle"
          [ngTemplateOutletContext]="{ label: 'Entwicklung und Earnings-Call' }"
        ></ng-container>
        <div class="section-items">
          @if (developmentText()) {
            <div class="update-item">
              <p class="update-text">{{ developmentText() }}</p>
            </div>
          }
          @if (earningsCallIntro()) {
            <div class="update-item">
              <p class="update-text">{{ earningsCallIntro() }}</p>
            </div>
          }
        </div>
      }

      @if (faqItems().length > 0) {
        <ng-container
          [ngTemplateOutlet]="sectionTitle"
          [ngTemplateOutletContext]="{ label: 'Fragen aus dem Call', count: faqItems().length }"
        ></ng-container>
        <ng-container [ngTemplateOutlet]="faqList"></ng-container>
      }
    </div>
  </app-v3-earnings-desktop-content>
} @else {
  <div class="earnings-analysis">
    @if (isFinnet()) {
      @if (isEarningsDateEnabled()) {
        <div class="card">
          <span class="date">{{ nextEarningsDate }}</span>
          <span class="subline">Nächster Earnings-Termin</span>
        </div>
      }

      @if (lastQuarterHighlight()) {
        <div class="card">
          <h3 class="header-label">Letztes Quartal</h3>
          <div class="quote">
            <span class="quote-notch"></span>
            <p class="quote-title">{{ lastQuarterHighlight() }}</p>
          </div>
        </div>
      }

      @if (revenueStats()) {
        <div class="card">
          <h3 class="header-label">Umsatz &amp; Gewinn</h3>
          <app-revenue-chart [earningsStats]="revenueStats()" [v3]="true"></app-revenue-chart>
        </div>
      }

      @if (epsData()) {
        <div class="card">
          <h3 class="header-label">EPS-Überraschung</h3>
          <ng-container [ngTemplateOutlet]="mobileEpsChart"></ng-container>
        </div>
      }

      @if (developmentText()) {
        <div class="card">
          <h3 class="header-label">Entwicklung</h3>
          <p class="body-text">{{ developmentText() }}</p>
        </div>
      }

      @if (hasUpdates()) {
        <div class="card">
          <h3 class="header-label">Updates aus den Earnings</h3>
          <ng-container
            [ngTemplateOutlet]="updateTabs"
            [ngTemplateOutletContext]="{ icons: false }"
          ></ng-container>
          <div class="update-list" [appV3TabPanel]="activeUpdateTab()">
            <ng-container
              [ngTemplateOutlet]="updateItems"
              [ngTemplateOutletContext]="{ icons: false }"
            ></ng-container>
          </div>
        </div>
      }

      @if (faqItems().length > 0) {
        <div class="card">
          <h3 class="header-label">Earnings-Call-FAQ</h3>
          <ng-container [ngTemplateOutlet]="faqList"></ng-container>
        </div>
      }

      @if (outlookText()) {
        <div class="card">
          <h3 class="header-label">Ausblick</h3>
          <p class="body-text">{{ outlookText() }}</p>
        </div>
      }
    } @else {
      @if (isEarningsDateEnabled()) {
        <div class="header">
          <span class="notch"></span>
          <span class="header-label">Nächster Termin</span>
        </div>
        <div class="card">
          <span class="date">{{ nextEarningsDate }}</span>
          <span class="subline">Nächster Earnings-Termin</span>
        </div>
      }

      @if (lastQuarterHighlight()) {
        <div class="header highlight-header">
          <span class="notch"></span>
          <span class="header-label">Letztes Quartal</span>
        </div>
        <div class="card">
          <p class="highlight-text">{{ lastQuarterHighlight() }}</p>
        </div>
      }

      @if (revenueStats()) {
        <div class="header highlight-header">
          <span class="notch"></span>
          <span class="header-label">Umsatz &amp; Gewinn</span>
        </div>
        <div class="card">
          <app-revenue-chart [earningsStats]="revenueStats()" [v3]="true"></app-revenue-chart>
        </div>
      }

      @if (epsData()) {
        <div class="header highlight-header">
          <span class="notch"></span>
          <span class="header-label">EPS-Überraschung</span>
        </div>
        <div class="card">
          <ng-container [ngTemplateOutlet]="mobileEpsChart"></ng-container>
        </div>
      }

      @if (developmentText()) {
        <div class="header highlight-header">
          <span class="notch"></span>
          <span class="header-label">Entwicklung</span>
        </div>
        <div class="card">
          <p class="body-text">{{ developmentText() }}</p>
        </div>
      }

      @if (hasUpdates()) {
        <div class="header highlight-header">
          <span class="notch"></span>
          <span class="header-label">Updates aus den Earnings</span>
          <span class="count">{{ updatesCount() }}</span>
        </div>
        <ng-container
          [ngTemplateOutlet]="updateTabs"
          [ngTemplateOutletContext]="{ icons: true }"
        ></ng-container>
        <div class="card" [appV3TabPanel]="activeUpdateTab()">
          <ng-container
            [ngTemplateOutlet]="updateItems"
            [ngTemplateOutletContext]="{ icons: true }"
          ></ng-container>
        </div>
      }

      @if (faqItems().length > 0) {
        <div class="header highlight-header">
          <span class="notch"></span>
          <span class="header-label">Earnings-Call-FAQ</span>
          <span class="count">{{ faqItems().length }}</span>
        </div>
        <div class="card">
          <ng-container [ngTemplateOutlet]="faqList"></ng-container>
        </div>
      }

      @if (outlookText()) {
        <div class="header highlight-header">
          <span class="notch"></span>
          <span class="header-label">Ausblick</span>
        </div>
        <div class="card">
          <p class="body-text">{{ outlookText() }}</p>
        </div>
      }
    }
  </div>
}

<ng-template #mobileEpsChart>
  <app-eps-chart [data]="epsData()" [v3]="true" [animateIn]="true" [steps]="3"></app-eps-chart>
  <div class="chart-footer">
    <div class="footer-legend">
      <span class="legend-item">
        <span class="legend-dot reported"></span>
        <span class="legend-label">Meldung</span>
      </span>
      <span class="legend-item">
        <span class="legend-dot expected"></span>
        <span class="legend-label">Erwartung</span>
      </span>
    </div>
    <p class="footer-source">
      Gewinn je Aktie in {{ epsSymbol() }} · Quelle: {{ dataSources.FACTSET }}
    </p>
  </div>
</ng-template>

<ng-template #updateTabs let-icons="icons">
  <div class="update-tabs">
    <button
      type="button"
      class="update-tab"
      [class.active]="activeUpdateTab() === 'positive'"
      (click)="selectUpdateTab('positive')"
    >
      @if (icons) {
        <span class="update-tab-icon positive"></span>
      }
      Positiv
    </button>
    <button
      type="button"
      class="update-tab"
      [class.active]="activeUpdateTab() === 'negative'"
      (click)="selectUpdateTab('negative')"
    >
      @if (icons) {
        <span class="update-tab-icon negative"></span>
      }
      Negativ
    </button>
  </div>
</ng-template>

<ng-template #updateItems let-icons="icons">
  @for (update of activeUpdates(); track update.title) {
    <div class="update-item">
      <span
        class="update-title"
        [class.positive]="icons && activeUpdateTab() === 'positive'"
        [class.negative]="icons && activeUpdateTab() === 'negative'"
      >
        @if (icons) {
          <span class="update-icon"></span>
        }
        {{ update.title }}
      </span>
      <p class="update-text">{{ update.text }}</p>
    </div>
  }
</ng-template>

<ng-template #faqList>
  <div class="faq-list">
    @for (item of faqItems(); track item.question; let i = $index) {
      <div class="faq-item">
        <div
          class="faq-question-row"
          role="button"
          tabindex="0"
          [attr.aria-expanded]="isFaqExpanded(i)"
          (click)="toggleFaq(i)"
          (keyup.enter)="toggleFaq(i)"
          (keydown.space)="$event.preventDefault(); toggleFaq(i)"
        >
          <span class="faq-question">{{ item.question }}</span>
          <span class="faq-arrow" aria-hidden="true" [class.expanded]="isFaqExpanded(i)"></span>
        </div>
        @if (isFaqExpanded(i)) {
          <p class="faq-answer">{{ item.answer }}</p>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #sectionTitle let-label="label" let-count="count">
  @if (isFinnet()) {
    <div class="section-header">
      <span class="section-notch"></span>
      <span class="section-label">{{ label }}{{ count !== undefined ? ' · ' + count : '' }}</span>
    </div>
  } @else {
    <div class="item-title-row">
      <span class="item-title">{{ label }}</span>
      @if (count !== undefined) {
        <span class="count">· {{ count }}</span>
      }
    </div>
  }
</ng-template>
